module.exports = __webpack_public_path__ + "static/media/cdb1.2d8fe3b6.png";